import { render, staticRenderFns } from "./CategoryBreadcrumbs.vue?vue&type=template&id=5bc588c4&scoped=true&"
import script from "./CategoryBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./CategoryBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryBreadcrumbs.vue?vue&type=style&index=0&id=5bc588c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc588c4",
  null
  
)

export default component.exports